import { useStorage } from '@vueuse/core'
import type { APIIntervals, APIOrderings, APIPromptTypeId, ItemType } from '../types/api'

export interface Filters {
  newest: boolean
  order_by: APIOrderings
  interval: APIIntervals
  type_ids?: APIPromptTypeId[]
  // premium?: APIPremium
  item_type?: ItemType
  is_premium?: boolean
}

export interface FilterQueries {
  order_by?: APIOrderings
  interval?: APIIntervals
  type_ids?: APIPromptTypeId[]
  // premium?: APIPremium
  is_premium?: boolean
  item_type?: ItemType
}

// Filters should be shared in the entire platform
export const useFilters = (orderBy: APIOrderings = 'votes') => useState<Filters>('filters', () => {
  const defaultInterval = 0
  const storage = useStorage(PROMPT_TYPE_STORAGE_KEY, PROMPT_TYPE_STORAGE_DEFAULT)

  return {
    newest: false,
    order_by: orderBy,
    interval: defaultInterval,
    type_ids: storage.value,
    // premium: 'all',
    is_premium: false,
    item_type: 'all',
  }
})

export const filtersToQueries = (filters: Filters): FilterQueries => {
  if (filters.newest) {
    return {
      order_by: 'newest',
      type_ids: filters.type_ids,
      // premium: filters.premium,
      is_premium: filters.is_premium,
    }
  }
  else {
    return {
      order_by: filters.order_by,
      interval: filters.interval,
      type_ids: filters.type_ids,
      // premium: filters.premium,
      is_premium: filters.is_premium,
      item_type: filters.item_type,
    }
  }
}
